// @flow

import React from 'react';
import type { Node } from 'react';
import { DiamondIcon, EmergingIcon, NewIcon } from '@riseart/icons';
import { artist as ENUM_ARTIST } from 'Enum';
import { FormattedMessage } from 'react-intl';

import { artistCareerStageCls } from 'shared_components/artist/CareerStage.less';

type Props = {
  stage: string,
};

/**
 * CareerStage
 * @param {Props} props
 * @returns {Node}
 */
export function ArtistCareerStage({ stage }: Props): Node {
  const IconComponent = {
    [ENUM_ARTIST.careerStage.NEW]: NewIcon,
    [ENUM_ARTIST.careerStage.EMERGING]: DiamondIcon,
    [ENUM_ARTIST.careerStage.ESTABLISHED]: EmergingIcon,
  }[stage];

  return IconComponent ? (
    <div className={artistCareerStageCls}>
      <IconComponent />
      <span>
        <FormattedMessage id={`components.artist.careerStage.${stage}`}>
          {(text: string) => text}
        </FormattedMessage>
      </span>
    </div>
  ) : null;
}
